// extracted by mini-css-extract-plugin
module.exports = {"racingPostRed":"#ed1a23","tippingBackground":"#fbf1f1","williamHillBlue":"#041338","coralBlue":"#004696","oddBoxRed":"#d11f25"};